import React, {useState} from "react";

export interface Question {
    question: string | React.ReactNode
    answer: string | React.ReactNode
}

export default function QuestionAnswerComponent(props: { questions: Question[] }) {
    return (
        <div className="accordion-container">
            {props.questions.map((question, index) => {
                return <SingleQuestion key={index} question={question} />
            })}
        </div>
    )
}

function SingleQuestion(props: { question: Question }) {
    const [open, setOpen] = useState(false);
    return (
        <>
            <span className={`accordion${open ? ' active' : ''}`} onClick={() => setOpen((prev) => !prev)}>
                <h3 className="title title--montserrat">{props.question.question}</h3>
                <div className="symbol">
                    <span></span>
                    <span></span>
                </div>
            </span>
            <div className={`accordion-content-container${open? ' active' : ''}`} style={{maxHeight: `${open ? '100%' : '0'}`}}>
                <div className="accordion-content">
                    {props.question.answer}
                </div>
            </div>
        </>
    )
}
